import { Pagination } from '@mui/material';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from 'react-icons/md';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import '../common-css/Table.css';
import { deleteItem, showTableResponse, sortInAlphabeticalOrder } from '../common-helpers/commonServices';
import CUET_TopicModal from './CUET_TopicModal';


const CUET_Topics = () => {
    const childRef = useRef();
    const [subjects, setSubjects] = useState([]);
    const [sections, setSections] = useState([]);
    const [topics, setTopics] = useState([]);
    const [selectedSubjects, setSelectedSubjects] = useState([]);
    const [selectedSections, setSelectedSections] = useState([]);
    // const [courses, setCourses] = useState([]);
    const [selectedExamType, setSectedExamType] = useState("All SUBJECT");
    const [selectedSubjectType, setSelectedSubjectType] = useState({ SubjectType: "All SUBJECT" });
    const [selectedSection, setSelectedSection] = useState({ Section: "All Topics" });
    const [currentPage, setCurrentPage] = useState(1);
    const [checked, setChecked] = useState(subjects);
    const [loadSubjects, setSubjectLoading] = useState(false);

    const getExamTypeLabel = (id) => {
        if (id === "Section-IA") return "Language Subjects";
        if (id === "Section-II") return "Domain-Specific Subjects";
        if (id === "Section-III") return "General Aptitude Test";
        return id || '';
    };

    const multiSortTopics = (array) => {
        return array.sort((a, b) => {
            const examTypeA = getExamTypeLabel(a.ExamType).toLowerCase();
            const examTypeB = getExamTypeLabel(b.ExamType).toLowerCase();
            if (examTypeA < examTypeB) return -1;
            if (examTypeA > examTypeB) return 1;

            const subjectA = a.SubjectType?.toLowerCase() || '';
            const subjectB = b.SubjectType?.toLowerCase() || '';
            if (subjectA < subjectB) return -1;
            if (subjectA > subjectB) return 1;

            const sectionA = a.Section?.toLowerCase() || '';
            const sectionB = b.Section?.toLowerCase() || '';
            if (sectionA < sectionB) return -1;
            if (sectionA > sectionB) return 1;

            const topicA = a.Topic?.toLowerCase() || '';
            const topicB = b.Topic?.toLowerCase() || '';
            if (topicA < topicB) return -1;
            if (topicA > topicB) return 1;

            return 0;
        });
    };

    //set Table data
    useEffect(() => {
        const response = axios.all([
            axios.get(BACKEND_SERVER_URL + '/cuet/subjects'),
            axios.get(BACKEND_SERVER_URL + '/cuet/sections'),
            axios.get(BACKEND_SERVER_URL + '/cuet/topics')
        ]);
        console.log(response);
        response.then(axios.spread((subjectsResponse, sectionsResponse, topicsResponse) => {
            let subjects = subjectsResponse.data.subjects;
            let sections = sectionsResponse.data.sections;
            let topics = topicsResponse.data.topics;
            console.log(sections);
            setSubjects(sortInAlphabeticalOrder(subjects, 'SubjectType'));
            setSections(sortInAlphabeticalOrder(sections, 'Section'));
            setTopics(multiSortTopics(topics));
            setChecked([...multiSortTopics(topics)]);
        })).catch((error) => {
            console.log(error);
            toast.error(error.response?.data?.message || "An error occurred while fetching subjects and sections.");
        });

    }, [loadSubjects])
    const pageSize = 100;
    const lastIndex = currentPage * pageSize;
    const firstIndex = lastIndex - pageSize;
    const records = checked?.slice(firstIndex, lastIndex);
    const npage = Math.ceil(checked?.length / pageSize)
    const number = [...Array(npage + 1).keys()].slice(1)

    const selectExamTypeHandler = (selectedExamType) => {
        setSelectedSubjectType({ SubjectType: "All SUBJECT" });
        setSelectedSection({ Section: "All Topics" });
        if (selectedExamType == 'All SUBJECT') {
            setChecked([...multiSortTopics(topics)]);
            setSectedExamType(selectedExamType);
            setSelectedSubjects([]);
            setSelectedSections([]);
            return;
        }
        setSectedExamType(selectedExamType);
        let filteredSubjects = subjects.filter(subject => subject.ExamType == selectedExamType);
        setSelectedSubjects(sortInAlphabeticalOrder(filteredSubjects, 'SubjectType'));
        let filteredTopics = topics.filter(topic => topic.ExamType == selectedExamType);
        setChecked([...multiSortTopics(filteredTopics)]);
    }

    const selectSubjectTypeHandler = (selectedSubjectType) => {
        if (selectedSubjectType == 'All SUBJECT') {
            let filteredTopics = topics.filter(topic => topic.ExamType === selectedExamType);
            setChecked(filteredTopics.length > 0 ? [...multiSortTopics(filteredTopics)] : [...multiSortTopics(topics)]);
            setSelectedSubjectType(selectedSubjectType);
            return;
        }
        console.log(selectedSubjectType);
        setSelectedSubjectType(selectedSubjectType);
        let filteredSections = sections.filter(subject => subject.SubjectTypeID == selectedSubjectType.Sn);
        setSelectedSections(sortInAlphabeticalOrder(filteredSections, 'Section'));
        let filteredTopics = topics.filter(topic => topic.SubjectTypeID == selectedSubjectType.Sn);
        setChecked([...multiSortTopics(filteredTopics)]);
    }
    const selectSectionHandler = (selectedSection) => {
        if (selectedSection == 'All Topics') {
            let filteredTopics = topics.filter(topic => topic.SubjectTypeID === selectedSubjectType.Sn);
            setChecked([...multiSortTopics(filteredTopics)]);
            setSelectedSection(selectedSection);
            return;
        }
        console.log(selectedSection);
        setSelectedSection(selectedSection);
        let filteredTopics = topics.filter(topic => topic.SectionID == selectedSection.Sn);
        setChecked([...multiSortTopics(filteredTopics)]);
    }



    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className=" page-title p-2 mb-2">{/*  flex-wrap  */}
                                <div className="row w-100 d-flex justify-content-between">
                                    <div className='col-12 d-flex flex-wrap justify-content-start align-items-center gap-2'>
                                        <div className="col-12 col-md-auto">
                                            <button type="button" className=" btn btn-dark btn-xs "
                                                style={{ whiteSpace: 'nowrap', backgroundColor: '#4d44b5', borderColor: '#4d44b5' }}
                                                onClick={() => childRef.current.openModal({
                                                    ExamType: selectedExamType !== 'All SUBJECT' && selectedExamType !== 'All Exam Types' ? selectedExamType : 'Section-IA',
                                                    SubjectType: selectedSubjectType.SubjectType !== 'All SUBJECT' ? selectedSubjectType.SubjectType : '',
                                                    SubjectTypeID: selectedSubjectType.Sn > 0 ? selectedSubjectType.Sn : 0,
                                                    Section: selectedSection.Section !== 'All Topics' ? selectedSection.Section : '',
                                                    SectionID: selectedSection.Sn > 0 ? selectedSection.Sn : 0
                                                })}
                                            >
                                                + SUB TOPIC
                                            </button>
                                        </div>
                                        <div className="col-12 col-md-auto d-flex flex-wrap justify-content-start align-items-center gap-2">
                                            <div className="col-12 col-sm-5 col-md-3" style={{ minWidth: '170px' }}>
                                                <div className="basic-dropdown">
                                                    <Select
                                                        value={[
                                                            { value: 'All Exam Types', label: 'All SUBJECT' },
                                                            { value: 'Section-IA', label: 'Language Subjects' },
                                                            { value: 'Section-II', label: 'Domain-Specific Subjects' },
                                                            { value: 'Section-III', label: 'General Aptitude Test' }
                                                        ].find(opt => opt.value === selectedExamType)}
                                                        onChange={(selectedOption) => selectExamTypeHandler(selectedOption.value)}
                                                        options={[
                                                            { value: 'All Exam Types', label: 'All SUBJECT' },
                                                            { value: 'Section-IA', label: 'Language Subjects' },
                                                            { value: 'Section-II', label: 'Domain-Specific Subjects' },
                                                            { value: 'Section-III', label: 'General Aptitude Test' }
                                                        ]}
                                                        styles={{
                                                            control: (provided) => ({
                                                                ...provided,
                                                                width: '100%',
                                                                backgroundColor: 'transparent',
                                                                borderColor: '#00a99d',
                                                                minHeight: '35px',
                                                                fontSize: '13px'
                                                            }),
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-5 col-md-3" style={{ minWidth: '170px' }}>
                                                <div className="basic-dropdown">
                                                    <Select
                                                        isDisabled={selectedExamType == 'All SUBJECT'}
                                                        value={{ value: selectedSubjectType, label: selectedSubjectType.SubjectType }}
                                                        onChange={(selectedOption) => selectSubjectTypeHandler(selectedOption.value)}
                                                        options={selectedSubjects?.map((subject) => ({ value: subject, label: subject.SubjectType }))}
                                                        styles={{
                                                            control: (provided) => ({
                                                                ...provided,
                                                                width: '100%',
                                                                backgroundColor: 'transparent',
                                                                borderColor: '#00a99d',
                                                                minHeight: '35px',
                                                                fontSize: '13px'
                                                            }),
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-5 col-md-3" style={{ minWidth: '170px' }}>
                                                <div className="basic-dropdown">
                                                    <Select
                                                        isDisabled={selectedSubjects.length == 0}
                                                        value={{ value: selectedSection, label: selectedSection.Section }}
                                                        onChange={(selectedOption) => selectSectionHandler(selectedOption.value)}
                                                        options={[{ Sn: 0, Section: 'All Topics' }, ...selectedSections]?.map((section) => ({ value: section, label: section.Section }))}
                                                        styles={{
                                                            control: (provided) => ({
                                                                ...provided,
                                                                width: '100%',
                                                                backgroundColor: 'transparent',
                                                                borderColor: '#00a99d',
                                                                minHeight: '35px',
                                                                fontSize: '13px'
                                                            }),
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    {/* <div className=" col-sm-4 input-group search-area mb-md-0 mb-3">
                                        <SearchBox setChecked={setChecked} dataArray={topics} searchingProperty={'Topic'} />
                                    </div> */}
                                </div>

                            </div>
                            {/* <ProdutsDetailsTabsAtTop setChecked={setChecked} totalItems={subjects} totalActiveItems={totalActiveSubjects} totalInactiveItems={totalInactiveSubjects} totalArchivedItems={totalArchivedSubjects} /> */}
                        </div>
                        <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                            <div className="d-sm-flex text-center justify-content-between align-items-center">
                                {/* <div>
                                    <Button variant="danger ms-3" size='xs' onClick={(e) => bulkOperations("delete", records, '/hideSubjects', 'Subjects', setSubjectLoading, loadSubjects)}>Delete</Button>
                                    <Button variant="success ms-3 " size='xs' onClick={(e) => bulkOperations("activate", records, '/activateSubjects', 'Subjects', setSubjectLoading, loadSubjects)}>Active</Button>
                                    <Button variant="warning ms-3" size='xs' onClick={(e) => bulkOperations("InActivate", records, '/inActivateSubjects', 'Subjects', setSubjectLoading, loadSubjects)}>Inactive</Button>
                                </div> */}

                                <div className='dataTables_info text-dark'>
                                    Records: {checked.length}
                                </div>
                                {checked.length > pageSize ? <div className="dataTables_paginate paging_simple_numbers justify-content-center  mb-0 pt-2"
                                    id="example-student_wrapper">
                                    <Pagination count={number.length} variant="outlined" color='primary' size="small" page={currentPage} siblingCount={1} boundaryCount={2} onChange={(e, p) => setCurrentPage(parseInt(p))} />
                                </div> : null}
                            </div>
                            <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                                <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                    <table className="table-responsive-lg table display dataTablesCard student-tab 
                                    dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }} id="example-student" >
                                        <thead style={{ backgroundColor: "#cccccc" }} >
                                            <tr className='text-center  border border-left'>
                                                {/* <th className=' custom-table-header p-2'>SN</th> */}
                                                <th className=' custom-table-header p-2 text-start'>All SUBJECT</th>
                                                <th className=' custom-table-header p-2 text-start'>SUBJECT NAME</th>
                                                <th className=' custom-table-header p-2 text-start'>TOPICS</th>
                                                <th className=' custom-table-header p-2  ps-3'>SUB TOPIC</th>
                                                {/* <th className=' custom-table-header p-2 text-start'>NO OF QUESTIONS</th>
                                                <th className=' custom-table-header p-2 text-start'>AVAILABLE QUESTIONS</th> */}


                                            </tr>
                                        </thead>
                                        <tbody>
                                            {records.length > 0 ? records.map((item, ind) => (
                                                <tr key={ind} className={`${ind % 2 == 1 ? 'custom row-height' : 'row-height'}`} >

                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "65px" }}>
                                                        <h6 className="mb-0 ">
                                                            {item.ExamType === "Section-IA" ? "Language Subjects" : item.ExamType === "Section-II" ? "Domain-Specific Subjects" : item.ExamType === "Section-III" ? "General Aptitude Test" : item.ExamType}
                                                        </h6>
                                                    </td>
                                                    <td className='p-1 text-statt' style={{ border: "1px solid #cccccc", width: "65px" }}>
                                                        <h6 className="mb-0 ">
                                                            {item.SubjectType}
                                                        </h6>
                                                    </td>
                                                    <td className='p-1 text-start' style={{ border: "1px solid #cccccc", width: "65px" }}>
                                                        <h6 className="mb-0 ">
                                                            {item.Section}
                                                        </h6>
                                                    </td>
                                                    <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                                                        <div className="d-flex justify-content-between ">
                                                            <h6 className='mb-0 ps-3' style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.Topic}
                                                                <CiEdit cursor='pointer' title='Edit SUB TOPIC' size={18} className='ms-3'
                                                                    onClick={() => childRef.current.openModal(item)} />
                                                                <MdDeleteOutline color="red" title='Delete SUB TOPIC' cursor='pointer' size={18} className='ms-2' onClick={() => { deleteItem(item.Sn, 'SUB TOPIC', '/cuet/deleteTopic/', setSubjectLoading, loadSubjects) }}
                                                                />
                                                            </h6>
                                                        </div>
                                                    </td>
                                                    {/* <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "65px" }}>
                                                        <h6 className="mb-0 ">
                                                            {item.NoOfQuestion}
                                                        </h6>
                                                    </td>
                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "65px" }}>
                                                        <h6 className="mb-0 ">
                                                            {item.AvailableQuestions}
                                                        </h6>
                                                    </td> */}

                                                </tr>
                                            )) :
                                                <tr>
                                                    <td colSpan="9" className="text-center">
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                                            {
                                                                showTableResponse(subjects, checked)
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CUET_TopicModal ref={childRef} loadSubjects={loadSubjects} setSubjectLoading={setSubjectLoading} />
        </>
    )
}

export default CUET_Topics;
